module.exports = __webpack_public_path__ + "static/media/mini-van.bda8dd7a.jpg";